<template>
  <md-button @click="onClick" class="md-primary button">
    <slot />
  </md-button>
</template>

<script>
export default {
  name: 'PrimaryButton',
  methods: {
    onClick() {
      this.$emit('click');
    },
  },
};
</script>

<style scoped lang="scss">
.md-primary.button {
  margin: 0;
  color: #ff5f3c;
  font-family: "Montserrat", sans-serif;
  font-weight: bold;
  font-size: 16px;
  height: 30px;
  text-transform: none;
}
</style>
